import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { EHRConnection, EHRFieldMapping, EHRSyncJob } from '../../services/ehrApi';

interface EHRState {
  loading: boolean;
  error: string | null;
  connections: EHRConnection[];
  syncJobs: EHRSyncJob[];
  fieldMappings: EHRFieldMapping[];
}

const initialState: EHRState = {
  loading: false,
  error: null,
  connections: [],
  syncJobs: [],
  fieldMappings: [],
};

const ehrSlice = createSlice({
  name: 'ehr',
  initialState,
  reducers: {
    setEHRLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setEHRError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setEHRConnections(state, action: PayloadAction<EHRConnection[]>) {
      state.connections = action.payload;
    },
    setEHRSyncJobs(state, action: PayloadAction<EHRSyncJob[]>) {
      state.syncJobs = action.payload;
    },
    setEHRFieldMappings(state, action: PayloadAction<EHRFieldMapping[]>) {
      state.fieldMappings = action.payload;
    },
    clearEHRState(state) {
      state.loading = false;
      state.error = null;
      state.connections = [];
      state.syncJobs = [];
      state.fieldMappings = [];
    },
  },
});

export const {
  setEHRLoading,
  setEHRError,
  setEHRConnections,
  setEHRSyncJobs,
  setEHRFieldMappings,
  clearEHRState,
} = ehrSlice.actions;

export default ehrSlice.reducer;

